import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import { PageHeader } from "antd";

import { getUrl, requests } from "../../globals/requests";
import {
  Container,
  SpaceBetween,
  CenterHorizontal,
} from "../../globals/styles";
import { Input, Button } from "../../components";
import { helpers } from "../../utils";
import "./styles.css";

import AdminData from "../AdminData/AdminData";

function EditOrganisation() {
  const [organisation, setOrganisation] = useState({
    name: "",
    street_address: "",
    state: "",
    country: "",
    verified: true,
  });
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  let { id: organisationId } = useParams();

  function handleInputChange(e) {
    const { name, value } = e.target;
    setOrganisation({ ...organisation, [name]: value });
  }

  useEffect(() => {
    async function getOrganisation() {
      try {
        setLoading(true);
        setErrMsg("");
        const url = `${getUrl("organisations")}/${organisationId}`;
        const response = await requests.getWithAuth(url);

        setOrganisation(response.data);
        setLoading(false);
      } catch (e) {
        helpers.displayMessage(e);
        setErrMsg(e.message);
        setLoading(false);
      }
    }

    getOrganisation();
  }, [organisationId]);

  async function handleEditOrganisation() {
    try {
      const url = `${getUrl("organisations")}/${organisationId}`;
      setLoading(true);
      const data = { ...organisation };
      await requests.putWithAuth(url, data);
      setLoading(false);
      helpers.successModal("Organisation updated!!!");
    } catch (e) {
      setLoading(false);
      helpers.displayMessage(e);
    }
    history.goBack();
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title={"Edit organisation"}
        subTitle="Organisation"
      />
      <SpaceBetween>
        <div>
          <p>
            <b>Name</b>
          </p>
          <Input
            name="name"
            onChange={handleInputChange}
            value={organisation.name}
          />
        </div>
        <div>
          <p className="edctrct-align-right">
            <b>Street address</b>
          </p>
          <Input
            name="street_address"
            onChange={handleInputChange}
            value={organisation.street_address}
          />
        </div>
      </SpaceBetween>
      <SpaceBetween>
        <div>
          <p>
            <b>State</b>
          </p>
          <Input
            name="state"
            onChange={handleInputChange}
            value={organisation.state}
          />
        </div>
        <div>
          <p className="edctrct-align-right">
            <b>Country</b>
          </p>
          <Input
            name="country"
            onChange={handleInputChange}
            value={organisation.country}
          />
        </div>
      </SpaceBetween>

      <CenterHorizontal>
        <Button
          onClick={handleEditOrganisation}
          loading={loading}
          title={"Update"}
          type="primary"
        />
      </CenterHorizontal>

      <AdminData organisation={organisation} />
    </Container>
  );
}

export default EditOrganisation;
